/* istanbul ignore file */
export enum StepNames {
  ClientDetailsAndSupportingDocument = "Client details and supporting document",
  PayeeDetails = "Payee Details",
  PaymentInstructions = "Payment instructions",
  Review = "Review",
  Complete = "Complete",
  Error = "Error",
}
